<template>
    <Cmembernav :curnavkv="curnavkv">

        <div v-if="navsub==0" class="profile">
            <div class="face">
                <div class="faceimg">
                    <ffupload :fileurl="me.face" @update:fileurl="updateface" :updata="{'mediatype':'avatar'}"></ffupload>
                </div>

            </div>
            <div class="info">
                <div v-if="!me.x_isedit" class="view">
                    <dl><dt>{{$common.dicword('username',true)}}</dt><dd>{{me.username}}</dd><dd class="subbtn"><a href="#" @click="navsub=2">{{$common.dicword('pwdsetting')}}</a></dd></dl>
                    <dl><dt>{{$common.dicword('mobile',true)}}</dt><dd>{{me.mobile}}</dd><dd class="subbtn"><a href="#" @click="navsub=1">{{$common.dicword('mobileset')}}</a></dd></dl>
                    <dl v-if="!$common.basic.chempty(me.schooltitle)"><dt>{{$common.dicword('school',true)}}</dt><dd>{{me.schooltitle}}</dd></dl>
                    <dl v-if="!$common.basic.chempty(me.classtitle)"><dt>{{$common.dicword('infoclass',true)}}</dt><dd>{{me.classtitle}}</dd></dl>
                    <dl><dt>{{$common.dicword('realname',true)}}</dt><dd v-html="me.realname"></dd></dl>
                    <dl><dt>{{$common.dicword('nickname',true)}}</dt><dd>{{me.showname}}</dd></dl>
                    <dl><dt>{{$common.dicword('birth',true)}}</dt><dd>{{$common.basic.dateformat( me.birth)}}</dd></dl>
                    <dl><dt>{{$common.dicword('gender',true)}}</dt><dd>{{$common.chgender(me.sex)}}</dd></dl>
                    <dl><dt>{{$common.dicword('address',true)}}</dt><dd>{{me.addr}}</dd></dl>
                    <dl><dt>&nbsp;</dt><dd><a href="#" class="btn1" @click="me.x_isedit=true">{{$common.dicword('modifyprofile')}}</a></dd></dl>
                </div>
                <div v-else class="edit">
                    <dl><dt>{{$common.dicword('nickname',true)}}</dt><dd><el-input v-model="me.showname" maxlength="50"></el-input></dd></dl>
                    <dl><dt>{{$common.dicword('birth',true)}}</dt><dd><el-date-picker type="date" v-model="me.birth" value-format="yyyy-MM-dd" maxlength="50"></el-date-picker></dd></dl>
                    <dl>
                        <dt>{{$common.dicword('gender',true)}}</dt>
                        <dd>
                            <el-radio-group v-model="me.sex">
                                <el-radio-button :label="1">{{$common.dicword('male')}}</el-radio-button>
                                <el-radio-button :label="2">{{$common.dicword('female')}}</el-radio-button>
                            </el-radio-group>
                        </dd>
                    </dl>
                    <dl><dt>{{$common.dicword('address',true)}}</dt><dd><el-input v-model="me.addr" maxlength="100"></el-input></dd></dl>
                    <dl><dt>&nbsp;</dt><dd class="btns"><a href="#" class="btn1" @click="saveprofile">{{$common.dicword('save')}}</a><a href="#" class="btncancel" @click="me.x_isedit=false">{{$common.dicword('cancel')}}</a></dd></dl>
                </div>
            </div>
        </div>
        <div v-if="navsub==1" class="mymobile">
            <dl><dt>{{$common.dicword('currentmobile',true)}}</dt><dd>{{me.mobile}}</dd></dl>
            <dl><dt>{{$common.dicword('pwd',true)}}</dt><dd><el-input type="password" v-model="pwdold" :class="{iserr:iserrpwdold}" @focus="iserrpwdold=false"></el-input></dd></dl>
            <dl><dt>{{$common.dicword('newmobile',true)}}</dt><dd><el-input v-model="mobilenew" :class="{iserr:iserrmobile}" @focus="iserrmobile=false"></el-input></dd></dl>
            <dl><dt>{{$common.dicword('vcode',true)}}</dt><dd><dl><dd class="vcode"><el-input v-model="vcode" maxlength="6" :class="{iserr:iserrvcode}" @focus="iserrvcode=false"></el-input></dd><dd class="vcodesend"><a v-if="vcodetime==0" href="#" @click="getvcode">{{$common.dicword('sendcode')}}</a><span v-if="vcodetime>0">{{vcodetime}}{{$common.dicword('sendcodewait')}}</span></dd></dl></dd></dl>
            <dl><dt v-if="!$store.getters.issmall">&nbsp;</dt><dd class="btns"><a href="#" class="btn1" @click="savemobile">{{$common.dicword('save')}}</a><a href="#" class="btncancel" @click="navsub=0">{{$common.dicword('cancel')}}</a></dd></dl>
        </div>

        <div v-if="navsub==2" class="mypwd">

            <template v-if="isforgetpwd">
                <dl><dt>{{$common.dicword('currentmobile',true)}}</dt><dd>{{me.mobile}}</dd></dl>
                <dl>
                    <dt>{{$common.dicword('vcode',true)}}</dt>
                    <dd>
                        <dl><dd class="vcode"><el-input autocomplete="off" v-model="vcode" maxlength="6" :class="{iserr:iserrvcode}" @focus="iserrvcode=false"></el-input></dd><dd class="vcodesend"><a v-if="vcodetime==0" href="#" @click="getvcode">{{$common.dicword('sendcode')}}</a><span v-if="vcodetime>0">{{vcodetime}}{{$common.dicword('sendcodewait')}}</span></dd></dl>
                    </dd>
                </dl>
                <dl><dt>{{$common.dicword('pwdnew',true)}}</dt><dd><el-input autocomplete="new-password" type="password" v-model="pwdnew" :class="{iserr:iserrpwdnew}" @focus="iserrpwdnew=false"></el-input></dd></dl>
                <dl><dt>{{$common.dicword('pwdconfirm',true)}}</dt><dd><el-input autocomplete="new-password" type="password" v-model="pwdconfirm" :class="{iserr:iserrpwdconfirm}" @focus="iserrpwdconfirm=false"></el-input></dd></dl>
                <dl><dt v-if="!$store.getters.issmall">&nbsp;</dt><dd class="btns"><a href="#" class="btn1" @click="resetpwd">{{$common.dicword('save')}}</a><a href="#" class="btncancel" @click="navsub=0">{{$common.dicword('cancel')}}</a></dd></dl>
            </template>
            <template v-else>
                <dl><dt>{{$common.dicword('pwdold',true)}}</dt><dd><el-input type="password" v-model="pwdold" :class="{iserr:iserrpwdold}" @focus="iserrpwdold=false"></el-input></dd></dl>
                <dl><dt>{{$common.dicword('pwdnew',true)}}</dt><dd><el-input type="password" v-model="pwdnew" :class="{iserr:iserrpwdnew}" @focus="iserrpwdnew=false"></el-input></dd></dl>
                <dl><dt>{{$common.dicword('pwdconfirm',true)}}</dt><dd><el-input type="password" v-model="pwdconfirm" :class="{iserr:iserrpwdconfirm}" @focus="iserrpwdconfirm=false"></el-input></dd></dl>
                <dl><dt>&nbsp;</dt><dd class="btns"><a href="#" class="btn1" @click="savepwd">{{$common.dicword('save')}}</a><a href="#" class="btncancel" @click="navsub=0">{{$common.dicword('cancel')}}</a><a href="#" @click="isforgetpwd=true">{{$common.dicword('getpwd')}}</a></dd></dl>
            </template>
        </div>
        <Vcode :show="showvcode"
               :img-num="3"
               title="手动小图片到正确位置"
               @success="vcodesuccess"
               @close="showvcode = false" style="z-index:9999" />
    </Cmembernav>
</template>

<script>
    import Vcode from 'vue-puzzle-vcode';

    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'profile',
        components: {
            Vcode
        },
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 3,
                me: {},
                pwdold: '',
                pwdnew: '',
                pwdconfirm: '',
                mobilenew: '',
                vcode: '',
                vcodetime: 0,
                myinterval: '',
                iserrmobile: false,
                iserrpwdnew: false,
                iserrpwdold: false,
                iserrpwdconfirm: false,
                iserrvcode: false,
                isforgetpwd: false,
                vcodeerror: 0,
                showvcode: false,
                vcodemobile: ''
            };
        },
        methods: {

            getdata: function () {
                let jsondata = { 'postdata': { 'api': 'member', 'act': 'myprofile' } };
                this.$common.post(jsondata, res => {
                    res.infodata.schooltitle = this.$common.basic.mydecode(res.schooltitle);
                    res.infodata.classtitle = this.$common.basic.mydecode(res.classtitle);
                    res.infodata.x_isedit = false;
                    this.me = res.infodata || {};
                });
            },
            saveprofile: function () {
                let jsondata = { 'postdata': { 'api': 'member', 'act': 'myprofilesave', 'data': this.me } };
                this.$common.post(jsondata, () => {
                    this.me.x_isedit = false;
                    this.$store.dispatch('setshowname', this.me.showname);
                });
            },
            updateface: function (v) {
                this.me.face = v;
                this.$store.dispatch('setface', this.me.face);
            },
            vcodesuccess() {
                //this.$common.success('验证成功！正在发送短信')
                this.showvcode = false;
                this.sendSMS()
                // 调用短信接口
            },
            getvcode: function () {
                let mobile = this.navsub == 1 ? this.mobilenew : this.me.mobile;
                this.iserrmobile = mobile == '';
                if (!this.iserrmobile) {
                    this.iserrmobile = this.$common.validate(mobile, "ismobile") == -1;
                }
                if (!this.iserrmobile) {
                    this.vcodemobile = mobile;
                    this.showvcode = true;
                }
            },
            sendSMS: function () {
                let jsondata = {
                    'postdata': {
                        'api': 'member', 'act': 'vcodeget', "data": { "t": this.navsub == 1 ? 1 : 0 }, "mobile": this.vcodemobile
                    }, 'msg': ''
                };
                this.$common.post(jsondata, () => {
                    this.vcodetime = 60;
                    this.vcodeerror = 0;
                });
            },
            savemobile: function () {
                this.iserrmobile = this.mobilenew == '';
                this.iserrpwdold = this.pwdold == '';
                this.iserrvcode = this.vcode == '';
                let isallow = (!this.iserrmobile) && (!this.iserrpwdold) && (!this.iserrvcode);
                if (isallow) {


                    if (this.vcodeerror < 5) {

                        let jsondata = {
                            'postdata': {
                                'api': 'member', 'act': 'mymobile', "data": { 'mobile': this.mobilenew, 'pwdold': this.pwdold, 'vcode': this.vcode }, "mobile": this.mobilenew
                            }, 'msg': 'Saveing...'
                        };
                        this.$common.post(jsondata, () => {
                            this.me.mobile = this.mobilenew;
                            this.navsub = 0;
                            this.mobilenew = ''
                            this.pwdold = ''
                            this.vcode = ''
                            this.me.x_isedit = false;
                        });
                        this.vcodeerror++;
                    }
                    else {
                        this.$common.fetch({ 'act': 'smscodeclear', 'msg': '', 'isautoback': false }, () => { });
                        this.$common.alert('验证码已失效，请重新获取验证码！');
                    }
                }
            },
            savepwd: function () {
                this.iserrpwdnew = this.pwdnew == '';
                this.iserrpwdold = this.pwdold == '';
                this.iserrpwdconfirm = this.pwdconfirm != this.pwdnew;
                let isallow = (!this.iserrpwdnew) && (!this.iserrpwdold) && (!this.iserrpwdconfirm);
                if (isallow) {
                    let jsondata = {
                        'postdata': {
                            'api': 'member', 'act': 'mypwd', "data": { 'pwdnew': this.pwdnew, 'pwdold': this.pwdold }
                        }, 'msg': 'Saveing...'
                    };
                    this.$common.post(jsondata, () => {
                        this.navsub = 0;
                        this.pwdnew = ''
                        this.pwdconfirm = ''
                        this.pwdold = ''
                        this.me.x_isedit = false;
                    });
                }
            },
            resetpwd: function () {
                this.iserrvcode = this.vcode == '';
                this.iserrpwdnew = this.pwdnew == '';
                this.iserrpwdconfirm = this.pwdconfirm != this.pwdnew;

                let isallow = (!this.iserrpwdnew) && (!this.iserrpwdconfirm) && (!this.iserrvcode);
                if (isallow) {


                    if (this.vcodeerror < 5) {
                        let jsondata = {
                            'postdata': {
                                'api': 'member', 'act': 'mypwdreset', "data": { 'pwdnew': this.pwdnew, 'vcode': this.vcode }, "mobile": this.me.mobile
                            }, 'msg': 'Saveing...'
                        };
                        this.$common.post(jsondata, () => {
                            this.navsub = 0;
                            this.pwdnew = ''
                            this.pwdconfirm = ''
                            this.vcode = ''
                            this.me.x_isedit = false;
                        });
                        this.vcodeerror++;
                    }
                    else {
                        this.$common.fetch({ 'act': 'smscodeclear', 'msg': '', 'isautoback': false }, () => { });
                        this.$common.alert('验证码已失效，请重新获取验证码！');
                    }
                }
            }
        },
        mounted() {
            this.getdata();
            let vm = this;
            this.myinterval = window.setInterval(function () {
                if (vm.vcodetime > 0) {
                    vm.vcodetime--;
                }
            }, 1000);

            this.$common.fetch({ 'act': 'smscodeclear', 'msg': '', 'isautoback': false }, () => { });//清除验证码
        },
        beforeDestroy() {
            window.clearInterval(this.myinterval);
        }
    }

</script>
